<zui-basic-info-header
  *ngIf="name"
  class="__header"
  [name]="name"
  [searchMatches]="searchMatches"
  [status]="status"
  [size]="nameSize"
  [generalTranslations]="generalTranslations"
  mode="project">
</zui-basic-info-header>

<!-- TODO: move to tooltip -->
<!-- <p class="__desc" *ngIf="description">
  {{ description }}
</p> -->

<div class="__tags" *ngIf="regularTags.length || mateTags.length || userProjectRole || locationLabel">

  <zui-project-access-chip
    *ngIf="userProjectRole && projectId"
    class="__access-chip"
    [projectId]="projectId"
    [roleCode]="userProjectRole"
    [disableLinks]="disableLinks"
  />

  <zui-project-location-chip
    *ngIf="locationLabel"
    class="__location-chip"
    [locationLabel]="locationLabel"
  />

  <ng-container *ngIf="regularTags.length || mateTags.length">
    <span *ngIf="userProjectRole || locationLabel" class="__separator">&#x2014;</span>

    <zui-project-mate-chip
      *ngIf="mateTags.length"
      class="__mate-chip"
      [tags]="mateTags"
      [disableLinks]="disableLinks"
    />

    <ng-container *ngIf="!disableLinks; else linkDisabledRef">
      <zui-tag
        *ngFor="let tag of regularTags; trackBy: trackByIndex;"
        [routerLink]="!disableLinks
          ? (activeTagFilter !== tag
            ? [ '/', 'dashboard', 'projects', routerParams | routerParams: 'tag' : tag ]
            : [ '/', 'dashboard', 'projects', routerParams | routerParams: 'tag' ])
          : undefined"
        class="__tags-tag"
        [class.is-active]="activeTagFilter === tag">
        {{ tag }}
      </zui-tag>
    </ng-container>

    <ng-template #linkDisabledRef>
      <zui-tag
        *ngFor="let tag of regularTags; trackBy: trackByIndex;"
        class="__tags-tag"
        (click)="activeTagFilter = tag"
        [class.is-active]="activeTagFilter === tag">
        {{ tag }}
      </zui-tag>
    </ng-template>
  </ng-container>

</div>
